/**
 * Add specific item to collection, if it doesn't already exist
 * @param {string[]} collection Collection to be updated
 * @param {string} item Current item
 * @return {string[]} The updated collection
 */
export const addToCollection = (collection, item) => {
    return item && collection.indexOf(item) < 0 ? [...collection, item] : collection;
};
//# sourceMappingURL=addToCollection.js.map